import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";

import { useStyles } from "../../../../Components/CSS/DetailStyle.css";
import AdminHeader from "../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import PageTitle from "../../../../Components/PageTitle/PageTitle";
import { url } from "../../../../Config/Config";
import Axios from "axios";
import CustomSiteLoader from "../../../../Components/CustomSiteLoader/CustomSiteLoader";
import { connect } from "react-redux";
import StaffCard from "./StaffCard/StaffCard";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";
import CustomBreadCrumbs from "../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class StaffDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      staffDetails: [],
    };
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      this.getStaff(this.props.match.params.id);
    }
  }

  getStaff = async (staffId) => {
    try {
      const response = await Axios.get(`${url}/api/staffs/${staffId}`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.staff.length !== 0) {
        this.setState({
          staffDetails: response.data.staff,
          isEmpty: false,
        });
      } else {
        this.setState({
          staffDetails: [],
          isEmpty: true,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getStaff(staffId);
      }
    }
  };

  render() {
    const { classes } = this.props;
    const { staffDetails } = this.state;
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle
            title="Staff Details"
            editUrl={`/administration/staffs/edit/${this.props.match.params.id}`}
            urlTitle="Edit Staff"
          />

          {staffDetails.length !== 0 ? (
            <Grid container spacing={3}>
              <StaffCard staff={staffDetails} />
            </Grid>
          ) : (
            this.state.isEmpty === false && <CustomSiteLoader />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(StaffDetail));
